export const FETCH_GAMESLIST_BEGIN = 'gameslist:FETCH_GAMESLIST_BEGIN'
export const FETCH_GAMESLIST_SUCCESS = 'gameslist:FETCH_GAMESLIST_SUCCESS'
export const FETCH_GAMESLIST_FAIL = 'gameslist:FETCH_GAMESLIST_FAIL'
export const ADD_GAME = 'gameslist:ADD_GAME'
